
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { EnhancedColorResult } from "./types";

export const analyzeColorWithAI = async (valueToAnalyze: string): Promise<EnhancedColorResult | null> => {
  console.log("🎨 Starting enhanced AI color analysis with COLOR priority for:", valueToAnalyze);
  
  try {
    const { data, error } = await supabase.functions.invoke('smart-color-analysis', {
      body: { 
        input: valueToAnalyze,
        userId: 'current-user'
      }
    });

    if (error) {
      console.error("Enhanced AI Analysis error:", error);
      throw error;
    }

    if (data && data.success) {
      const result: EnhancedColorResult = {
        ...data,
        timestamp: new Date()
      };
      
      // Enhanced success notification with COLOR MATCH detection
      const exactColorMatches = result.inventoryMatches.filter(m => m.colorMatch).length;
      const exactSizeMatches = result.learningMetrics.exactSizeMatchesFound || 0;
      const exactMatches = result.learningMetrics.exactMatchesFound || 0;
      
      let successMessage = `Verbeterde AI Analyse voltooid!`;
      let description = `${result.basePrediction.baseColor} basis voorgesteld (${Math.round(result.basePrediction.confidence * 100)}% zekerheid)`;
      
      if (exactColorMatches > 0 && exactSizeMatches > 0) {
        successMessage += ` ✅ Perfecte match!`;
        description = `${exactColorMatches} exacte kleur & maat matches gevonden - ${description}`;
      } else if (exactColorMatches > 0) {
        successMessage += ` 🎨 Juiste kleur gevonden!`;
        description = `${exactColorMatches} kleur matches (andere maat) - ${description}`;
      } else if (exactMatches > 0) {
        successMessage += ` ⚠️ Product gevonden, verkeerde kleur`;
        description = `Product gevonden maar verkeerde kleur - ${description}`;
      }
      
      toast.success(successMessage, { description });

      // Enhanced inventory results notification
      if (result.inventoryMatches.length > 0) {
        const bestMatch = result.inventoryMatches[0];
        const hasColorMatch = bestMatch.colorMatch;
        const hasSizeMatch = bestMatch.sizeMatch;
        
        let matchMessage = `${result.inventoryMatches.length} matches gevonden`;
        let matchDescription = `${bestMatch.product_naam}`;
        
        if (hasColorMatch && hasSizeMatch) {
          matchDescription += ` ✅ Perfecte match (${bestMatch.eenheid})`;
        } else if (hasColorMatch) {
          matchDescription += ` 🎨 Juiste kleur, andere maat: ${bestMatch.eenheid} (gevraagd: ${bestMatch.requestedSize})`;
        } else if (hasSizeMatch) {
          matchDescription += ` 📏 Juiste maat, verkeerde kleur (${bestMatch.eenheid})`;
        } else {
          matchDescription += ` ⚠️ Alternatief: ${bestMatch.eenheid}`;
        }
        
        toast.info(matchMessage, { description: matchDescription });
      } else {
        toast.warning("Geen exacte matches gevonden", {
          description: "Probeer een externe aanvraag of controleer spelling en kleurcode"
        });
      }

      return result;
    } else {
      throw new Error(data?.error || 'Enhanced analyse gefaald');
    }
    
  } catch (error) {
    console.error("Enhanced color analysis error:", error);
    toast.error("Verbeterde AI Kleuranalyse gefaald", {
      description: error instanceof Error ? error.message : "Onbekende fout opgetreden"
    });
    return null;
  }
};
